import { Separator } from "../components/Separator";
import { cn } from "../lib/utils";
import React from "react";
import { Button } from "./Button";
import { Icon } from "./Icon";
export function Page({ children, variant = "normal" }) {
    const mainVariantClasses = variant === "normal" ? "h-full py-16" : "h-full py-4 px-2";
    const divVariantClassNames = variant === "normal" ? "gap-6 px-6" : "gap-4";
    return (React.createElement("main", { className: mainVariantClasses },
        React.createElement("div", { className: cn("mx-auto flex h-full max-w-4xl flex-col text-sm font-normal", "text-foreground", divVariantClassNames) }, children)));
}
Page.Header = function ({ title, description, icon }) {
    return (React.createElement(Page.Vertical, { gap: "xs" },
        React.createElement(Icon, { visual: icon, className: "text-primary-400", size: "lg" }),
        typeof title === "string" ? (React.createElement(Page.H, { variant: "h3" }, title)) : (React.createElement(React.Fragment, null, title)),
        description && React.createElement(Page.P, { variant: "secondary" }, description)));
};
Page.SectionHeader = function ({ title, description, action, }) {
    return (React.createElement(Page.Horizontal, { gap: "md" },
        React.createElement(Page.Vertical, { gap: "xs", sizing: "grow" },
            React.createElement(Page.H, { variant: "h5" }, title),
            React.createElement(Page.P, { variant: "secondary" }, description)),
        action && (React.createElement("div", null,
            React.createElement(Button, { ...action })))));
};
Page.Separator = function () {
    return React.createElement(Separator, null);
};
const PsizeClasses = {
    xs: "copy-xs",
    sm: "copy-sm",
    md: "copy-base",
    lg: "copy-lg",
};
Page.P = function ({ children, variant, size = "sm" }) {
    return (React.createElement("p", { className: cn(PsizeClasses[size], variant === "secondary" ? "text-muted-foreground" : "text-foreground") }, children));
};
Page.H = function ({ children, variant = "h3" }) {
    const Component = variant;
    const hSizes = {
        h1: "heading-4xl",
        h2: "heading-3xl",
        h3: "heading-2xl",
        h4: "heading-xl",
        h5: "heading-lg",
        h6: "heading-base",
    };
    return (React.createElement(Component, { className: cn("text-foreground", hSizes[variant]) }, children));
};
const gapSizes = {
    xs: "gap-1",
    sm: "gap-2",
    md: "gap-3",
    lg: "gap-5",
    xl: "gap-8",
    none: "",
};
Page.Layout = function ({ children, direction = "vertical", sizing, align = "stretch", gap = "lg", }) {
    switch (direction) {
        case "horizontal":
            return (React.createElement(Page.Horizontal, { children: children, sizing: sizing, align: align, gap: gap }));
        case "vertical":
            return (React.createElement(Page.Vertical, { children: children, sizing: sizing, align: align, gap: gap }));
        case "fluid":
            return (React.createElement(Page.Fluid, { children: children, sizing: sizing, align: align, gap: gap }));
        default:
            return null;
    }
};
Page.Horizontal = function ({ children, sizing, align = "left", gap = "lg", }) {
    return (React.createElement("div", { className: cn("flex flex-col sm:flex-row", sizing === "grow" ? "grow basis-0" : "", sizing === "shrink" ? "shrink" : "", gapSizes[gap], align === "left" ? "justify-start" : "", align === "center" ? "justify-center" : "", align === "right" ? "justify-end" : "", align === "stretch" ? "justify-stretch" : "") }, children));
};
Page.Vertical = function ({ children, sizing, align = "left", gap = "md", }) {
    return (React.createElement("div", { className: cn("flex flex-col", sizing === "grow" ? "grow basis-0" : "", sizing === "shrink" ? "shrink" : "", gapSizes[gap], align === "left" ? "items-start" : "", align === "center" ? "items-center" : "", align === "right" ? "items-end" : "") }, children));
};
Page.Fluid = function ({ children, sizing, align = "stretch", gap = "xs", }) {
    return (React.createElement("div", { className: cn("flex flex-wrap", sizing === "grow" ? "grow" : "", sizing === "shrink" ? "shrink" : "", gapSizes[gap], align === "left" ? "items-start" : "", align === "center" ? "items-center" : "", align === "right" ? "items-end" : "") }, children));
};
//# sourceMappingURL=Page.js.map